/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { avatarsControllerRedirectToAvatar } from "./avatarsControllerRedirectToAvatar";

export function avatarsService() {
  return { avatarsControllerRedirectToAvatar }
}